import { createI18n } from 'vue-i18n'

class I18nInstance {
  constructor() {
    this.i18n = createI18n({
      legacy: false,
      globalInjection: true,
      locale: 'en',
      warnHtmlMessage: 'off',
      messages: {},
      silentTranslationWarn: true
    })
  }

  // 修改 locale 的方法
  setLocale(newLocale) {
    console.log('LGSdk.i18n---多语言标识', newLocale)
    this.i18n.global.locale.value = newLocale
  }

  // 添加或修改消息的函数
  setMessage(newLocale, newMessages) {
    // console.log('LGSdk.i18n---多语言文本', newLocale, newMessages)
    this.i18n.global.setLocaleMessage(newLocale, {
      ...Object.fromEntries(
        Object.entries(newMessages).filter(([, value]) => value !== '')
      )
    })
  }

  // 获取浏览器语言的方法
  t(key, data) {
    // 获取当前语言环境文本，如果没有则使用英文文本
    const result = this.i18n.global.t(key, data)
    return result
  }

  // install 方法，用于在 Vue 应用中注册插件
  install(app) {
    app.use(this.i18n)
  }
}

// 导出 I18nService 实例
const i18nInstance = new I18nInstance()
export default i18nInstance
